import { render, staticRenderFns } from "./CardResult.vue?vue&type=template&id=29acc654&scoped=true&"
import script from "./CardResult.vue?vue&type=script&lang=js&"
export * from "./CardResult.vue?vue&type=script&lang=js&"
import style0 from "./CardResult.vue?vue&type=style&index=0&id=29acc654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29acc654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
